/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perm_Product_Analytics_Profiles_ReadInputs */



/**
* | output |
* | --- |
* | "Member profiles and leaderboards" |
*
* @param {Perm_Product_Analytics_Profiles_ReadInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perm_product_analytics_profiles_read = /** @type {((inputs?: Perm_Product_Analytics_Profiles_ReadInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perm_Product_Analytics_Profiles_ReadInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Профили участников и таблицы лидеров")
	return /** @type {LocalizedString} */ ("Member profiles and leaderboards")
});